<template>
    <div id="count1">
        <transition name="fade">
            <Loading v-if="isLoading"/>
        </transition>
        <goTop/>
        <step :stepNumber="1"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">保費試算</h2>
                <attention/>
                <h3 class="blueTitle">國內旅行綜合險保費快算</h3>
                <div v-if="policyTypeSwitch === 'I'" class="attentionTxt"><img src="noticemark.svg" alt="notice" class="attention"><p>目前僅開放滿18歲以上旅客幫自己一人投保，需用自己的信用卡，如有多人投保或其他需求，請改洽各<a class="tw_addr_accu" href="https://www.tmnewa.com.tw/location" target="_blank">分支機構</a>詢問。</p></div>
                <ul class="topBtn" v-else>
                    <li
                        v-for="(item,itemKey) in collection"
                        :key="itemKey"
                        :class="[{ active: current === item.id },'people_tab_accu' + item.id]"
                        @click="topBtnEffect(item.id)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
                <div class="form">
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle">
                                旅遊國家
                                <div class="tooltip" data="國內旅遊地區僅限台灣本島與離島。">
                                <img
                                    src="../assets/attention.svg"
                                    class="attentionImg"
                                />
                                </div>
                                <a :href="overseasURL" class="overseas_accu" target="_blank">國外旅遊由此去</a>
                            </div>
                            <input ref="countryInput" type="text" class="inputStyle clarity-unmask" readonly value="台灣">
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ pinkText: check2 }">
                                投保<span v-if="policyTypeSwitch === 'I'">身份</span><span v-else>人數</span>年齡
                                <div class="tooltip" data="請必選自己的身份及所屬的年齡區間" v-if="policyTypeSwitch === 'I'">
                                    <img
                                        src="../assets/attention.svg"
                                        alt=""
                                        class="attentionImg"
                                    />
                                </div>
                                <div class="tooltip" data="一次可投保至多4人。"  v-else>
                                     <img
                                         src="../assets/attention.svg"
                                         alt=""
                                         class="attentionImg"
                                     />
                                </div>
                            </div>
                            <div v-if="policyTypeSwitch === 'I'">
                                <select name="" id="" class="inputStyle arrow clarity-unmask" v-model="insureCounted" :class="{ alert: check2 }">
                                    <option :value="0" disabled selected>請選擇身份與年齡</option>
                                    <option :value="1">大人(滿18歲~未滿70歲)</option>
                                    <option :value="2">長者(滿70歲~未滿80歲)</option>
                                </select>
                                <p class="alertStr"></p>
                            </div>
                            <div v-else>
                                <input
                                    ref="insureInput"
                                    readonly
                                    class="inputStyle arrow"
                                    :class="{ alert: check2 }"
                                    :value="insureCounted + '位'"
                                    @click="toggleInsureCount()"
                                    placeholder="請選擇投保人數"

                                />
                                <p class="alertStr"></p>
                                <div ref="insureArea" v-show="showCountPop" id="insureArea" :class="{ alert: check2 }">
                                    <div class="close" v-if="showCountPop" @click="showCountPop = false"><img src="../assets/close.svg" alt=""></div>
                                    <insureCount :initInsureCount="initInsureCount" @clickCount="showInsureCount"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle" :class="{ pinkText: check3 }">
                                旅遊期間(保險期間)
                                <div class="tooltip" data="僅開放選擇近30天內之日期投保，保險期間最長可至14天，一天以24小時計算。建議保險期間涵蓋「從家裡出發起至外地返家止」，讓保障更周全。">
                                    <img
                                        src="../assets/attention.svg"
                                        alt="僅開放選擇近30天內之日期投保，保險期間最長可至14天，一天以24小時計算。建議保險期間涵蓋「從家裡出發起至外地返家止」，讓保障更周全。"
                                        class="attentionImg"
                                    />
                                </div>
                            </div>
                            <date-picker
                                v-model:value="startDate"
                                placeholder="出發日(建議從家裡出發起)"
                                value-type="date"
                                class="inputStyle calendar startDate"
                                :lang="lang"
                                :editable="false"
                                :disabled-date="limitStartRange"
                                @pick="changeStartEndDate"
                                @change="changeStartEndDate"
                                :class="{ alert: check3 }"
                            ></date-picker>
                            <p class="alertStr"></p>
                            <select
                                id="timeSelect"
                                class="inputStyle arrow clarity-unmask"
                                v-model="effTime"
                                @change="changeStartEndDate"
                                v-if="!mobileSelectTime"
                                :class="{ alert: check5 }"
                            >
                                <option value="" disabled>請選擇時間</option>
                                <option :value="item.time" v-for="(item,itemKey) in timeRange" :key="itemKey">{{ item.time }}</option>
                            </select>
                            <p class="alertStr"></p>
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle"></div>
                            <date-picker
                                v-model:value="endDate"
                                valueType="date"
                                placeholder="返回日(建議從外地返家止)"
                                class="inputStyle calendar endDate"
                                :disabled-date="limitEndRange"
                                :editable="false"
                                @pick="changeStartEndDate"
                                @change="changeStartEndDate"
                                :lang="lang"
                                :class="{ alert: check4 }"
                            >
                            </date-picker>
                            <p class="alertStr"></p>
                            <select
                                id="timeSelect"
                                class="inputStyle arrow clarity-unmask"
                                v-model="effTime"
                                @change="changeStartEndDate"
                                v-if="mobileSelectTime"
                                :class="{ alert: check5}"
                            >
                                <option value="" disabled>請選擇時間</option>
                                <option :value="item.time" v-for="(item,itemKey) in timeRange" :key="itemKey">{{ item.time }}</option>
                            </select>
                            <p class="alertStr"></p>
                            <div class="inputStyle dateTxt clarity-unmask">{{startEndDateTime}}<span v-if="startEndDateTime === ''">-  旅遊期間 / 保險期間  -</span></div>
                        </div>
                    </div>
                    <div class="oneline">
                        <div class="inputTitle">
                            活動代碼
                            <div class="tooltip" data="代碼僅可輸入1組，若無代碼則不需填寫。">
                                <img
                                    src="../assets/attention.svg"
                                    alt="attention"
                                    class="attentionImg"
                                />
                            </div>
                        </div>
                        <input
                            type="text"
                            placeholder="非必填"
                            class="inputStyle clarity-unmask"
                            v-model="referrerCode"
                            v-on:blur="checkReferrerCode"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <div class="btn center count1_go_accu" type="submit" @click="checkCount1Page">
                試算保費
            </div>
        </div>
    </div>
</template>
<script setup>
        import $ from "jquery"
        import {onMounted, onUnmounted, reactive, ref, watch} from "vue";
        import goTop from "@/components/gotop.vue";
        import step from "@/components/step.vue";
        import gtm from "@/utils/gtmDataLayer";
        import {popUp} from "@/utils/popUp";
        import attention from "@/components/attention.vue";
        import {useRoute, useRouter} from "vue-router";
        import {getApi, postApi} from "@/utils/callApi";
        import Swal from "sweetalert2";
        import apiConfig from "@/utils/apiConfig";
        import Loading from "@/components/loading.vue";
        import insureCount from "@/components/count1/insureCount.vue";
        import moment from "moment";
        import DatePicker from 'vue-datepicker-next';
        import 'vue-datepicker-next/index.css';

        const route = useRoute();//擷取網址參數
        const router = useRouter();//轉跳router
        const overseasURL = ref();
        const policyTypeSwitch = ref("I");//網要開關
        const mobileSelectTime = ref(false);
        const isLoading = ref(false);
        let referrerCode = ref("");//活動代碼
        let trackingCode = ref("");//lineTravel活動代碼
        let pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
        const current = ref(2);//頁面顯示投保預設方式
        const collection = reactive([
            {id: 1, name: "多人一起保"},
            {id: 2, name: "幫自己保"},
            {id: 3, name: "幫他人保"}
        ]);//頁面顯示投保方式

        //國家選擇
        //let countryList = ref([]);//頁面顯示國家清單
        //let showCountryPop = ref(false);//是否顯示國家清單
        //const reloadCountrySelectKey = ref(0);//重載國家清單component
        //let tags = ref([]);//加入的標籤
        //let tag = ref('');//輸入的標籤
        //let autocompleteItems = [];//標籤自動完成清單

        // 年齡區間選擇
        const insureCounted = ref(0);//投保年齡人數合計
        const initInsureCount = ref(null);//預設insureCount
        const showCountPop = ref(false);//是否顯示人數清單
        let insureCountList = []; //選擇人數清單

        //投保區間選擇
        const timeRange = reactive([
            //頁面顯示時間清單
            {time: "00:00"},
            {time: "01:00"},
            {time: "02:00"},
            {time: "03:00"},
            {time: "04:00"},
            {time: "05:00"},
            {time: "06:00"},
            {time: "07:00"},
            {time: "08:00"},
            {time: "09:00"},
            {time: "10:00"},
            {time: "11:00"},
            {time: "12:00"},
            {time: "13:00"},
            {time: "14:00"},
            {time: "15:00"},
            {time: "16:00"},
            {time: "17:00"},
            {time: "18:00"},
            {time: "19:00"},
            {time: "20:00"},
            {time: "21:00"},
            {time: "22:00"},
            {time: "23:00"}
        ])//時間下拉選單
        const lang = ref({
            formatLocale: {
                monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
            },
            monthBeforeYear: false,
        })

        //設定datepicker介面
        const startDate = ref(null);//保期開始
        const endDate = ref(null);//保期結束
        const effTime = ref("");//保期時間
        const startEndDateTime = ref("");//顯示旅遊時間與天數
        let minDate = null;//可選保期起始
        let countDays = 0;//保險天數
        let checkCountData = {}///用來顯示checkCountpage content alert的資料
        //國家與人數點擊外面收合
        const insureInput = ref(null);
        const insureArea = ref(null);

        //國家與人數點擊外面收合
        const clickOutSide= (e)=>{
            if(policyTypeSwitch.value !== "I"){
                if (!(insureInput.value.contains(e.target) ||insureArea.value.contains(e.target))) {
                    showCountPop.value = false;
                }
            }
        }
        const handleResize = ()=>{
            const windowWidth = window.innerWidth;
            if (windowWidth <= 650) {
                mobileSelectTime.value = true
            }else{
                mobileSelectTime.value = false
            }
        }
        //網投網要開關
        const getPolicyTypeSwitch = ()=>{
            getApi(apiConfig.getPolicyTypeSwitch).then((response) => {
                var getPolicyTypeSwitch = response.data;
                if (getPolicyTypeSwitch.code === 200) {
                    policyTypeSwitch.value = getPolicyTypeSwitch.data;
                } else {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>' + '資料載入錯誤' + '</p>',
                    });
                }
            }).catch(() => {
                //跳出錯誤
                Swal.fire({
                    title: "頁面載入錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>常用清單載入錯誤</p>',
                })
            })

        }
        //帶入活動代碼
        const insertReferrerCode = ()=>{
            const urlReferrerCode = sessionStorage.getItem('referrerCode');
            if(route.query.referrerCode){
                referrerCode.value = route.query.referrerCode;
                sessionStorage.setItem('referrerCode' ,referrerCode.value);
                checkReferrerCode();
            }
            if(urlReferrerCode){
                referrerCode.value = urlReferrerCode;
                checkReferrerCode();
            }
        }
        //帶入lineTravel代碼
        const lineTravelCode = ()=>{
            const lineTrackingCode = sessionStorage.getItem('trackingCode');
            // URL 有帶 tag 優先，統一存成 trackingCode
            if (route.query.tag) {
                trackingCode.value = route.query.tag;
                sessionStorage.setItem('trackingCode', trackingCode.value);
                return; // 已儲存 URL 的值，不再讀取舊的 sessionStorage
            }
            // 沒有 URL 參數時讀取已儲存的 trackingCode
            if (lineTrackingCode) {
                trackingCode.value = lineTrackingCode;
            }
        }

        //檢查活動代碼
        const checkReferrerCode = ()=>{
            referrerCode.value = referrerCode.value.toUpperCase(); //強制轉大寫
            if (referrerCode.value !== "") {
                var data = {
                    code: referrerCode.value,
                    clsType: "TA"
                };
                postApi(
                    apiConfig.checkChannelReferrer,
                    null,
                    null,
                    null,
                    data
                )
                    .then(response => {
                        var codeCheckRes = response.data;

                        if (codeCheckRes.code === 200) {
                            if (!codeCheckRes.data) {
                                //顯示活動代碼錯誤
                                referrerCode.value = "";
                                Swal.fire({
                                    title: "檢查活動代碼錯誤",
                                    showConfirmButton: false,
                                    showCloseButton: true,
                                    html: '<img src="error.svg"><p>無此活動代碼</p>',
                                });
                            }
                        } else {
                            //跳出錯誤
                            Swal.fire({
                                title: "檢查活動代碼錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg"><p>'+ codeCheckRes.message + '</p>',
                            });
                        }
                    })
                    .catch(() => {
                        //跳出錯誤
                        Swal.fire({
                            title: "檢查活動代碼錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>連線錯誤</p>',
                        });
                    });
            }
        }
        //取得客戶選取之人數
        const showInsureCount = (childInsureCount)=> {
            insureCountList = childInsureCount;
            insureCounted.value = 0;
            insureCountList.forEach(insure => {
                insureCounted.value += insure.count;
            });
            getEffDateTime();

        }
        const loadPageStorage= ()=>{
            if (pageStorage) {
                effTime.value = pageStorage.effTime;
                startDate.value = moment(pageStorage.startDate).toDate();
                endDate.value = moment(pageStorage.endDate).toDate();
                startEndDateTime.value = pageStorage.startEndDateTime;
                policyTypeSwitch.value = pageStorage.getPolicyTypeSwitch;
                insureCounted.value = pageStorage.insureCounted;
                initInsureCount.value = pageStorage.insureCountList;//更新insureCount.vue
                if (policyTypeSwitch.value === 'A') {
                    showInsureCount(pageStorage.insureCountList);
                }
            }

            // } else {
            //     var now = moment().startOf('day').toDate();
            //     var end = moment(now).add(1 ,'d').toDate();
            //     startDate.value = now;
            //     endDate.value = end;
            // }

        }
        //取得可投保時間區間
        const getEffDateTime = () => {
            var data = {
                travelArea:"A",
                adultCount: insureCountList.length === 0 ? 0: insureCountList[0].count,
                elderCount: insureCountList.length === 0 ? 0: insureCountList[1].count,
                youthCount: insureCountList.length === 0 ? 0: insureCountList[2].count,
                childCount: insureCountList.length === 0 ? 0: insureCountList[3].count,
                babyCount: insureCountList.length === 0 ? 0: insureCountList[4].count

            };
            postApi(
                apiConfig.getEffDateTime, null, null, null, data)
                .then(response => {
                    const effDateTimeRes = response.data;
                    if (effDateTimeRes.code === 200) {
                        minDate = effDateTimeRes.data.effDateTimeStart;
                        if(moment(startDate.value).startOf('day').isBefore(minDate, 'day')){
                            startDate.value = moment(minDate).startOf('day').toDate();
                            endDate.value = moment(minDate).add(1, 'd').toDate();
                        }
                        changeStartEndDate();

                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ effDateTimeRes.message + '</p>',
                        });
                    }
                })
                .catch(() => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>投保區間載入錯誤</p>',
                    }).then(function () {
                        router.push("/");
                    });
                });
        }
        //載入國家清單
        // const getCountryList= () => {
        //     LoadData.getCountryList(function (data) {
        //         countryList.value = data;
        //         countryList.value.forEach(country =>{
        //             autocompleteItems.push(
        //                 { "text": country.name }
        //             )
        //         });
        //         reloadCountrySelectKey.value++;
        //     });
        // }

        const topBtnEffect = (id) => {
            current.value = id;

            switch(current.value){
                case 1:
                    Swal.fire({
                        title: "多人一起保",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        customClass: {
                            container: "noticeAlert",
                            confirmButton: "people_confirm_accu1",
                        },
                        html: '<img src="noticemark.svg"><p>幫7歲以上家人一起投保需回傳要保書，提醒您：最遲須於旅遊出發日前3個工作天以前完成投保。</p>',
                    });
                    break;
                case 2:
                    Swal.fire({
                        title: "幫自己保",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        customClass: {
                            container: "noticeAlert",
                            confirmButton: "people_confirm_accu2",
                        },
                        html: '<img src="noticemark.svg"><p>滿18歲以上可幫自己保，需用自己的信用卡<!--或帳戶付款-->。</p>',
                    });
                    break;
                case 3:
                    Swal.fire({
                        title: "幫他人保",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        customClass: {
                            container: "noticeAlert",
                            confirmButton: "people_confirm_accu3",
                        },
                        html: '<img src="noticemark.svg"><p>1.幫他人保需使用自己的信用卡付款。</p><p>2.幫7歲以上家人投保需回傳要保書，提醒您：最遲須於旅遊出發日前3個工作天以前完成投保。</p>'
                    });
                    break;
            }


        }

        //顯示投保人數選單
        const toggleInsureCount= () => {
            showCountPop.value = !showCountPop.value;
        }
        //檢核參數
        let startCheck = false;
        const check2 = ref(false);
        const check3 = ref(false);
        const check4 = ref(false);
        const check5 = ref(false);

        //檢查count1紅色框
        const checkForm = ()=>{
            if(startCheck){
                if(insureCounted.value === 0){
                    check2.value = true;
                }else{
                    check2.value = false;
                }
                if(startDate.value === null){
                    check3.value = true;
                }else{
                    check3.value = false;
                }
                if(endDate.value === null){
                    check4.value = true;
                }else{
                    check4.value = false;
                }
                if(effTime.value === ""){
                    check5.value = true;
                }else{
                    check5.value = false;
                }
            }
        }
        //檢查count1頁面輸入資料
        const checkCount1Page = () => {
            startCheck = true;
            checkForm();
            let checkFlag = 0;
            const errorMsg = [];
            //檢查投保人數
            let elderCount = 0;
            let adultCount = 0;
            let youthCount = 0;
            let childCount = 0;
            let babyCount = 0;
            if(!check2.value){
                if(policyTypeSwitch.value === 'I'){ //關閉網要人數設定
                    insureCountList = [
                        {title: '大人(滿15歲-未滿70歲)', count: 0},
                        {title: '長者(滿70歲-未滿80歲)', count: 0},
                        {title: '大人(滿18歲-未滿70歲)', count: 0},
                        {title: "青少年(滿15歲-未滿18歲)", count: 0},
                        {title: "兒童(滿7歲-未滿15歲)", count: 0},
                        {title: "幼童(0歲-未滿7歲)", count: 0}
                    ]
                    if(insureCounted.value === 1){
                        elderCount = 1;
                        insureCountList[0].count = 0;
                        insureCountList[1].count = 1;
                    } else if (insureCounted.value === 2){
                        adultCount = 1;
                        insureCountList[0].count = 1;
                        insureCountList[1].count = 0;
                    }
                }else{
                    elderCount = insureCountList[0].count;
                    adultCount = insureCountList[1].count;
                    youthCount = insureCountList[2].count;
                    childCount = insureCountList[3].count;
                    babyCount = insureCountList[4].count;
                }
            }else{
                checkFlag++;
                errorMsg.push("請選擇投保人數");
            }

            //檢查旅遊期間

            if(!check3.value && !check4.value && !check5.value){
                var effDateTime =
                    moment(startDate.value).format("YYYY-MM-DD") +
                    " " +
                    effTime.value +
                    ":00";
                var expDateTime =
                    moment(endDate.value).format("YYYY-MM-DD") +
                    " " +
                    effTime.value +
                    ":00";
            }else{
                checkFlag++;
                errorMsg.push("旅遊期間未填寫完全");
            }


            if (checkFlag === 0) {
                isLoading.value = true;
                var data = {
                    effDateTime: effDateTime,
                    expDateTime: expDateTime,
                    elderCount: elderCount,
                    adultCount: adultCount,
                    youthCount: youthCount,
                    childCount: childCount,
                    babyCount: babyCount,
                    travelArea:"A",
                };

                postApi(apiConfig.checkCountPage, null, null, null, data)
                    .then(response => {
                        let checkCount1Res = response.data;
                        checkCountData = checkCount1Res.data;
                        if (checkCount1Res.code === 200) {
                            isLoading.value = false;
                            var pageStorage = {
                                current: current.value,
                                insureCountList: insureCountList,
                                startDate:startDate.value,
                                endDate:endDate.value,
                                effTime: effTime.value,
                                startEndDateTime: startEndDateTime.value,
                                referrerCode: referrerCode.value,
                                countDays:countDays.value,
                                getPolicyTypeSwitch: policyTypeSwitch.value,
                                insureCounted:insureCounted.value
                            };

                            pageStorage.policyType = checkCount1Res.data.policyType; //取得網投網要

                            pageStorage.globalHidePlan = {
                                buyUneasy: !checkCount1Res.data.buyUneasyPolicySwitch,//旅遊不便險
                                buyCar: !checkCount1Res.data.buyCarPolicySwitch,//租借汽車
                                buyMotor: !checkCount1Res.data.buyMotorPolicySwitch,//租借機車
                                buyTriathlon: !checkCount1Res.data.buyTriathlonSwitch,//三鐵
                                buyTraffic: !checkCount1Res.data.buyTrafficAccidentSwitch,//交通意外
                                // buyBurn: !checkCount1Res.data.buyBurnPolicySwitch//重大燒燙傷
                            };


                            sessionStorage.setItem(
                                "pageStorage",
                                JSON.stringify(pageStorage)
                            );

                            Swal.fire({
                                title: "保期確認",
                                confirmButtonText: "已經確認",
                                cancelButtonText:"重新填寫",
                                reverseButtons:true,
                                showCancelButton:true,
                                showCloseButton:true,
                                allowOutsideClick:false,
                                customClass: {
                                    container: "checkDate",
                                    confirmButton: "date_confirm_accu",
                                    cancelButton: "date_rewrite_accu",
                                    closeButton: "date_close_accu",
                                },
                                html:
                                    '<p>本次投保的保險期間為 : </p>' +
                                    '<p class="checkDateTxt">['+
                                    startEndDateTime.value +
                                    ']</p>'+
                                    '<p>請再檢視保期是否正確。</p>'+
                                    '</br>'+
                                    '<p>(提醒您，保期以24小時為一單位，若您預計回程日的時間會晚於出發時間，建議投保天數再多加一天，讓保障更周全更完整。)</p>'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    if(checkCountData.content === undefined){
                                        router.push("/count2");
                                    }else{
                                        Swal.fire({
                                            title: "投保審核",
                                            confirmButtonText: "確定",
                                            showCloseButton: true,
                                            html: '<img src="noticemark.svg" alt="notice"><p>'+ checkCountData.content + '</p>'
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                router.push("/count2");
                                            }
                                        });
                                    }

                                } else if (result.isDenied) {
                                    Swal.close()
                                }

                            });
                        } else {
                            Swal.fire({
                                title: "填寫資料錯誤",
                                showConfirmButton: false,
                                showCloseButton: true,
                                html: '<img src="error.svg" alt="error"><p>'+ checkCount1Res.message + '</p>'
                            });
                            isLoading.value = false;
                        }
                    })
                    .catch(() => {
                        Swal.fire({
                            title: "資料錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg" alt="error"><p><p>檢查資料連線錯誤</p>'
                        });
                        isLoading.value = false;
                    });
            } else {
                Swal.fire({
                    title:"填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    html: '<img src="error.svg" alt="error"><p>'+ errorMsg + '</p>',
                })
                isLoading.value = false;
            }
            if(referrerCode.value !== "" || referrerCode.value !== null){
                const fpcInfo = JSON.parse(sessionStorage.getItem("fpcInfo"));
                postApi(apiConfig.event, null, null, null,{
                    tagName: "(新保)保費試算頁_活動代碼",
                    tagValue:referrerCode.value,
                    sessionId: fpcInfo.sessionId,
                    fpc: fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    insuranceType: "旅平險",
                })
            }
        }

        //更新保險期間
        const changeStartEndDate = () => {
            if(moment(startDate.value, 'day').isSameOrAfter(endDate.value, 'day')){
                endDate.value = moment(startDate.value).add(1, 'd').toDate();
            }
            if(moment(endDate.value, 'day').isAfter(moment(startDate.value).add(14, 'd'))){
                endDate.value = moment(startDate.value).add(14, 'd').toDate();
            }

            var startDateStr = moment(startDate.value);
            var endDateStr = moment(endDate.value);
            var diffDays = endDateStr.diff(startDateStr, "days");

            if (!startDateStr.isValid() || !endDateStr.isValid() || effTime.value === "") {
                startEndDateTime.value = "";
            } else {
                startEndDateTime.value =
                    startDateStr.format("YYYY-MM-DD") +
                    " " +
                    effTime.value +
                    " ~ " +
                    endDateStr.format("YYYY-MM-DD") +
                    " " +
                    effTime.value +
                    " 共" +
                    diffDays +
                    "天";
            }
            countDays = diffDays
        }
        //出發日禁選日期
        const limitStartRange = (date)=> {
            return moment(date).isBefore(minDate, 'day') || moment(date).isAfter(moment().add(29,'d') ,'day');
        }
        //返回日禁選日期
        const limitEndRange = (date)=>{
            return moment(date).isBefore( moment(startDate.value).add(1,'d')) || moment(date).isAfter(moment(startDate.value).add(14,'d'));

        }
        // const filteredItems = computed(()=>{
        //     return autocompleteItems.filter(i =>{
        //         return i.text.toLowerCase().indexOf(tag.value.toLowerCase()) !== -1;
        //     });
        // })
        //網投網要開關
        getPolicyTypeSwitch();
        //檢查網址帶入活動代碼
        insertReferrerCode();
        lineTravelCode();
        onMounted(()=>{
            gtm.pageViewEvent();//新增pageViewEvent
            popUp();//公告系統
            overseasURL.value = location.href.replace('taiwan', 'overseas');
            var fixStyle = $("body").css("overflow");
            if (fixStyle === "hidden") {
                $("body").removeAttr("style");
            }
            window.addEventListener("click", clickOutSide);
            window.addEventListener("resize", handleResize);
            //初始化載入(不放在setup 因為有順序問題)
            //getCountryList();
            handleResize();
            loadPageStorage();
            getEffDateTime();
            //回到最初將會清除部分Storage
            let removeStorage = ['detailStorage','applicationNo','insTraOrderId','confirmPolicyType','otp','fromPage','registerStorage'];
            removeStorage.forEach(k =>
                sessionStorage.removeItem(k)
            )
        });
        onUnmounted(()=>{
            window.removeEventListener("click", clickOutSide);
            window.removeEventListener("resize", handleResize);
        })
        //監聽檢核參數
        watch(()=>[insureCounted.value,effTime.value,startDate.value,endDate.value,effTime.value],
            ()=>{
                checkForm();
        })
</script>
<style lang="scss">
#count1 {
    .inputStyle span{top:0;left:0}
    .inputTitle a{
        color: #3197FA;
        text-decoration: underline;
        cursor: pointer;
    }
    .topBtn {
        width: 420px;
        margin: 0 auto;
        border: 1px solid $gray;
        border-radius: 30px;
        display: flex;
        @media screen and (max-width: $small) {
            width: 100%;
        }

        li {
            color: $gray;
            font-size: 18px;
            border-radius: 30px;
            width: 33.3333%;
            text-align: center;
            padding: 15px 0;
            cursor: pointer;
            font-weight: 500;

            @media screen and (max-width: $small) {
                padding: 10px 0;
                font-size: 16px;
            }

            &.active {
                background: $blue-700;
                color: #fff;
                transition: all 300ms ease-in-out;
            }
        }
    }
    .dateTxt{
        border-radius: 20px;
        color: $gray;
        background:$noTouchGray;
        letter-spacing: -0.2px;
        line-height: 37px;
        box-sizing: border-box;
        @media screen and (max-width: $small) {
            margin-top:10px;
        }
    }
    textarea {
        resize: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    #insureArea,.countrySelectFrame{position:relative}
    .reportrange-text {
        background-color: transparent;
        padding: 0px;
        border: 0px;
    }

    .ti-input{
        border: 0;
        padding-left: 0;
    }
    .vue-tags-input{height:auto;min-height:40px;
        &.ti-focus{
            border: 1px solid #CACCCF;
            border-bottom: 2px solid #00A69C;
            outline: none;
        }
        @media screen and (max-width: $small) {max-width:100%}
    }
    .ti-selected-item{background:$blue-700;}
    .ti-autocomplete{
        left: 0;
        border-radius: 10px;
    }
    .close {
        position: absolute;
        z-index: 102;
        right: 5px;
        cursor: pointer;
        bottom: -27px;
        border-radius: 5px;
        height:22px;
        img{width: 23px;
            height: 21px;
        }
        @media screen and (max-width: $small) {
            width:30px;height:28px;bottom:-32px;
            img{width: 30px;
                height: 26px;
            }
        }
    }
    .link {
        display: block;
        margin: 50px 0;
    }
    .calendar {
        margin-bottom:10px;
        width:100%;
        .mx-input-wrapper{
            height:100%;
            display: flex;
            line-height:35px;
            input{
                border:0;background:none;font-size: 16px;width:calc(100% - 65px);padding:0;
            }
            i{display:none;}
        }
        &.alert{
            margin-bottom:0;
        }
    }
    .mx-calendar-content .cell.active{background-color:$blue-700;}
    @media screen and (max-width: $small) {
        .inputStyle.red {
            font-size: 14.5px;
        }
        .daterangepicker .drp-calendar {
            width: 100%;
            min-width: 100%;
        }
        #timeSelect {
            margin: 10px 0 0;
        }
    }

}
.noticeAlert{
    @media screen and (max-width: $small) {
        .swal2-html-container {
            img{margin:0 0 10px;}
            p{text-align: left;margin:5px 0;}

        }
    }
}
#insureArea{
    border: 0;
}
.mx-calendar-content .cell.active{
    background-color:$blue-700;
}
@media screen and (max-width: $small) {
    .mx-datepicker-popup{
        width:90%;
    }
    .mx-calendar{width:100%;}
}
.checkDate .checkDateTxt{
    font-weight:bold;
    color:$pink;
}
@media screen and (max-width: $small) {
    .swal2-container.checkDate .swal2-title{
        padding:0
    }
}


</style>
